import { useMutation } from "@tanstack/react-query";
import customerService from "..";

function useRemoveCustomer() {
  return useMutation({
    mutationFn: (id: number) => {
      return customerService.deleteCustomer(id);
    },
  });
}

export default useRemoveCustomer;
